<script setup lang="ts">
import FlagsLanguage from "../FlagsLanguage.vue";
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useStaysStore } from "@/stores";

const staysStore = useStaysStore();

const showMobileMenu = ref(false);


onMounted(async () => {
  const closeMenuOnClickOutside = (event: MouseEvent) => {
    if (event.target && !(event.target as Element).closest(".header")) {
      showMobileMenu.value = false;
    }
  };
  document.addEventListener("click", closeMenuOnClickOutside);

  const smoothScroll: EventListener = (event) => {
    event.preventDefault();
    const targetId = (event.target as HTMLAnchorElement)
      .getAttribute("href")
      ?.substring(1);
    if (targetId) {
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const anchorLinks = document.querySelectorAll("nav a");
  anchorLinks.forEach((link) => {
    link.addEventListener("click", smoothScroll);
  });

  onUnmounted(() => {
    document.removeEventListener("click", closeMenuOnClickOutside);
    anchorLinks.forEach((link) => {
      link.removeEventListener("click", smoothScroll);
    });
  });
});

const dialogTransition = computed(() =>
  showMobileMenu.value ? "slide-in" : "slide-out"
);

const shouldShowSupportedLanguages = computed(() => {
  return (
    (staysStore.lastReservationData?.supportedLanguages &&
      staysStore.lastReservationData?.supportedLanguages.length > 1) ||
    (staysStore.lastCompanyData?.supportedLanguages &&
      staysStore.lastCompanyData?.supportedLanguages.length > 1) ||
    (staysStore.lastReservationData?.user?.supportedLanguages && staysStore.lastReservationData?.user?.supportedLanguages?.length > 1)
  
  );
});

</script>

<template>
  <v-app-bar style="box-shadow: none; position: relative" class="my-1 custom__app__bar" app color="transparent"
    :transition="dialogTransition" dark>
    <v-container class="custom-container header">
      <img src="/img/icons/lightBlueLogo.png" alt="Selfie Checkin Logo" class="logo-image" />
      <v-spacer></v-spacer>
      <FlagsLanguage v-if="shouldShowSupportedLanguages" :supported-languages="(staysStore.lastReservationData?.supportedLanguages) || (staysStore.lastCompanyData?.supportedLanguages) || (staysStore.lastReservationData?.user?.supportedLanguages)" />
    </v-container>
  </v-app-bar>
</template>

<style scoped>
.custom__app__bar :deep(.v-toolbar__content) {
  height: max-content !important;
}

.logo-image {
  height: 3rem;
  width: auto;
}

.custom-container.header {
  display: flex;
  align-items: center;
}

.header nav {
  display: flex;
  align-items: center;
}

.flag-container {
  display: flex;
  gap: 1rem;
}

.flag-icon {
  cursor: pointer;
  width: 2rem;
  height: 2rem;
}

</style>
